import React from 'react';
import { Colors } from '../../Constants/colors';

interface Props {
  totalSteps: number;
  currentStep: number;
}
/* {Array.from({ length: noOfEmergencyContact }, (_, index) => { */
const Steps = ({ totalSteps, currentStep }: Props) => {
  return (
    <div
      className="flex justify-center w-full p-4 h-32"
      style={{
        borderBottom: `2px solid ${Colors.LightAshRose}`,
      }}
    >
      <div className="flex gap-6 w-full">
        {Array.from({ length: totalSteps }, (_, index) => {
          return (
            <div
              className="flex justify-start gap-2 items-center"
              style={{
                flex: `${index + 1 !== totalSteps ? 1 : 0}`,
              }}
            >
              <div
                style={{
                  borderRadius: '50%',
                  width: '32px',
                  height: '32px',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  backgroundColor: `${
                    index + 1 === currentStep ? Colors.LightAshRose : ''
                  }`,
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    borderRadius: '50%',
                    width: '80%',
                    height: '80%',
                    backgroundColor:
                      index + 1 <= currentStep
                        ? Colors.CrimsonRed
                        : Colors.LightAshRose,
                    color:
                      index + 1 <= currentStep ? Colors.White : Colors.DarkGrey,
                  }}
                  className="text-sm font-extralight"
                >
                  {index + 1}
                </div>
              </div>

              {index + 1 !== totalSteps ? (
                <div
                  style={{
                    height: '2px',
                    borderRadius: '10px',
                    backgroundColor:
                      index + 1 < currentStep
                        ? Colors.AshRose
                        : Colors.LightAshRose,
                    flex: 1,
                    transition: 'background-color 0.5s ease',
                  }}
                />
              ) : (
                <></>
              )}
            </div>
          );
        })}
      </div>

      <></>
    </div>
  );
};

export default Steps;
